import {ToggleControl} from '../../../components/Controls/ToggleControl';
import {EditedProject} from '../EditedProject';

export function DemoProjectStatusControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    const disabled = project.ControlledByAutomation;

    return (
        <ToggleControl
            label="Demo project"
            checked={project.DemoProject}
            disabled={disabled}
            onChange={({checked}) =>
                setProjectAndValidate({
                    ...project,
                    DemoProject: checked
                })
            }
        />
    );
}
